import * as React from 'react';

import { FlexContainer, FlexContainerProps, IVerticalOffset } from '../Container';
import { QuickLink } from './QuickLink';
import { QuickLinkRedesign } from './QuickLinkRedesign';
import { IQuickLinks } from '../../models/content.interfaces';
import styled from 'styled-components';
import { BREAK_POINTS } from '../../consts/style';

const StyledFlexContainer = styled<FlexContainerProps & { redesign?: boolean }>(FlexContainer)`
  ${(p) =>
    p.redesign &&
    `
  @media (min-width: ${BREAK_POINTS.MIN.SM}) {
    box-shadow: 0 0 16px 0 rgba(0, 0, 0, 0.16);
    flex-wrap: nowrap;
  }
  @media (min-width: ${BREAK_POINTS.MIN.MD}) {
    box-sizing: border-box;
    margin: ${p.verticalOffset || 0}px 32px 32px;
  }
  @media (min-width: 1140px){
    margin: ${p.verticalOffset || 0}px auto 32px;
  }
`}
`;

export const QuickLinks = ({ items, redesign, verticalOffset }: IQuickLinks & IVerticalOffset) => {
  const QuickLinkComponent = redesign ? QuickLinkRedesign : QuickLink;
  return (
    <StyledFlexContainer
      redesign={redesign}
      data-comment="QuickLinks"
      verticalOffset={verticalOffset}
    >
      {items &&
        items.map(({ headline, buttonUrl, iconSvg }) => {
          const empty = !headline && !buttonUrl && !iconSvg;
          return empty ? null : (
            <QuickLinkComponent headline={headline} url={buttonUrl} icon={iconSvg} key={headline} />
          );
        })}
    </StyledFlexContainer>
  );
};
